import { Component, Emit, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import BriefingCard from '@/shared/cards/briefing/briefing-card/briefing-card.vue';
import type { IBriefingPage, IResourceModel } from '@/shared/model/briefing-widget.model';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import ListLoading from '@/entities/resource-management/list-loading/list-loading.vue';
import { namespace } from 'vuex-class';
import CompanyBriefingAgentCard from '@/v2/components/briefing-agent/modal/add-company-agent/briefing-company-card.vue';
import UserMyPageService from '@/service/userMyPage.service';
import BriefingService from '@/service/briefing.service';

const appStoreState = namespace('appStore');
const briefingStore = namespace('briefingStore');

@Component({
  computed: {},
  methods: {},
  components: {
    'company-briefing-agent-card': CompanyBriefingAgentCard,
    'briefing-card': BriefingCard,
    'list-loading': ListLoading,
    'vue-custom-scrollbar': vueCustomScrollbar,
  },
})
export default class AddCompanyAgent extends Vue {
  @Prop(Boolean) readonly openModal;

  @Inject('briefingService')
  private briefingService: () => BriefingService;

  @Emit('close') close() {
    this.companyAgents = [];
    this.page = 0;
  }

  @briefingStore.Getter
  public getFeaturedCompanies!: IResourceModel[];

  @Emit('select')
  select(item: IBriefingPage) {
    return item;
  }

  @Inject('userMyPageService')
  private userMyPageService: () => UserMyPageService;

  @briefingStore.Mutation
  public setSelectedResource!: (payload: IResourceModel) => void;

  @appStoreState.Mutation
  public setShowDetailReport!: (b: boolean) => void;

  @appStoreState.Mutation
  public setShowDetailTopic!: (b: boolean) => void;

  @briefingStore.Getter
  public getSelectedResource!: IResourceModel;

  @appStoreState.Mutation
  public setShowDetailArticles!: (b: boolean) => void;

  companyAgents: IBriefingPage[] = [];
  isLoadMore = false;
  isLoading = true;
  isSearching = false;
  keyword = '';
  page = 0;
  size = 10;

  @Watch('openModal')
  onOpenModalChange() {
    this.fetchCompanyData();
  }

  fetchCompanyData() {
    const userKey = this.$store.getters?.userIdentity?.id;
    this.isLoading = true;
    this.briefingService()
      .getAllCompanyBriefingPage(userKey, undefined, this.page, this.size)
      .then(res => {
        this.companyAgents = this.companyAgents.concat(res.data?.body?.briefingPageList);
        this.isLoadMore = res.data?.body?.loadMore;
      })
      .finally(() => {
        this.isLoading = false;
      });
    this.page++;
  }

  search(e: any) {
    const { value } = e?.target;
    this.keyword = value.trim();
    this.companyAgents = [];
    this.page = 0;
    if (value) {
      this.fetchSearchCompanyData();
    } else {
      this.fetchCompanyData();
      this.keyword = '';
      this.isSearching = false;
    }
  }

  private fetchSearchCompanyData() {
    const userKey = this.$store.getters?.userIdentity?.id;
    this.isSearching = true;
    this.isLoading = true;
    this.briefingService()
      .getAllCompanyBriefingPage(userKey, undefined, this.page, this.size, true, undefined, this.keyword)
      .then(res => {
        this.companyAgents = res.data?.body?.briefingPageList;
        this.isLoadMore = res.data?.body?.loadMore;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  infinityScroll(e: Event) {
    const el = e.target as HTMLElement;
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 50 && this.isLoadMore) {
      if (this.isSearching) {
        this.fetchSearchCompanyData();
      } else {
        this.fetchCompanyData();
      }
    }
  }

  @Emit('view-detail-report')
  viewDetail(item) {}
}
